import { JurisdictionOfFormation, LegalType, } from '../../__generated__/graphql';
/**
 * Helpers
 */
export var JurisdictionDisplayName;
(function (JurisdictionDisplayName) {
    JurisdictionDisplayName["CA"] = "Canada";
    JurisdictionDisplayName["GB"] = "United Kingdom";
    JurisdictionDisplayName["US_AK"] = "Alaska, United States";
    JurisdictionDisplayName["US_AL"] = "Alabama, United States";
    JurisdictionDisplayName["US_AR"] = "Arkansas, United States";
    JurisdictionDisplayName["US_AZ"] = "Arizona, United States";
    JurisdictionDisplayName["US_CA"] = "California, United States";
    JurisdictionDisplayName["US_CO"] = "Colorado, United States";
    JurisdictionDisplayName["US_CT"] = "Connecticut, United States";
    JurisdictionDisplayName["US_DC"] = "District of Columbia, United States";
    JurisdictionDisplayName["US_DE"] = "Delaware, United States";
    JurisdictionDisplayName["US_FL"] = "Florida, United States";
    JurisdictionDisplayName["US_GA"] = "Georgia, United States";
    JurisdictionDisplayName["US_HI"] = "Hawaii, United States";
    JurisdictionDisplayName["US_IA"] = "Iowa, United States";
    JurisdictionDisplayName["US_ID"] = "Idaho, United States";
    JurisdictionDisplayName["US_IL"] = "Illinois, United States";
    JurisdictionDisplayName["US_IN"] = "Indiana, United States";
    JurisdictionDisplayName["US_KS"] = "Kansas, United States";
    JurisdictionDisplayName["US_KY"] = "Kentucky, United States";
    JurisdictionDisplayName["US_LA"] = "Louisiana, United States";
    JurisdictionDisplayName["US_MA"] = "Massachusetts, United States";
    JurisdictionDisplayName["US_MD"] = "Maryland, United States";
    JurisdictionDisplayName["US_ME"] = "Maine, United States";
    JurisdictionDisplayName["US_MI"] = "Michigan, United States";
    JurisdictionDisplayName["US_MN"] = "Minnesota, United States";
    JurisdictionDisplayName["US_MO"] = "Missouri, United States";
    JurisdictionDisplayName["US_MS"] = "Mississippi, United States";
    JurisdictionDisplayName["US_MT"] = "Montana, United States";
    JurisdictionDisplayName["US_NC"] = "North Carolina, United States";
    JurisdictionDisplayName["US_ND"] = "North Dakota, United States";
    JurisdictionDisplayName["US_NE"] = "Nebraska, United States";
    JurisdictionDisplayName["US_NH"] = "New Hampshire, United States";
    JurisdictionDisplayName["US_NJ"] = "New Jersey, United States";
    JurisdictionDisplayName["US_NM"] = "New Mexico, United States";
    JurisdictionDisplayName["US_NV"] = "Nevada, United States";
    JurisdictionDisplayName["US_NY"] = "New York, United States";
    JurisdictionDisplayName["US_OH"] = "Ohio, United States";
    JurisdictionDisplayName["US_OK"] = "Oklahoma, United States";
    JurisdictionDisplayName["US_OR"] = "Oregon, United States";
    JurisdictionDisplayName["US_PA"] = "Pennsylvania, United States";
    JurisdictionDisplayName["US_RI"] = "Rhode Island, United States";
    JurisdictionDisplayName["US_SC"] = "South Carolina, United States";
    JurisdictionDisplayName["US_SD"] = "South Dakota, United States";
    JurisdictionDisplayName["US_TN"] = "Tennessee, United States";
    JurisdictionDisplayName["US_TX"] = "Texas, United States";
    JurisdictionDisplayName["US_UT"] = "Utah, United States";
    JurisdictionDisplayName["US_VA"] = "Virginia, United States";
    JurisdictionDisplayName["US_VT"] = "Vermont, United States";
    JurisdictionDisplayName["US_WA"] = "Washington, United States";
    JurisdictionDisplayName["US_WI"] = "Wisconsin, United States";
    JurisdictionDisplayName["US_WV"] = "West Virginia, United States";
    JurisdictionDisplayName["US_WY"] = "Wyoming, United States";
})(JurisdictionDisplayName || (JurisdictionDisplayName = {}));
export var LegalTypeDisplayName;
(function (LegalTypeDisplayName) {
    LegalTypeDisplayName["INC"] = "Incorporated (Inc.)";
    LegalTypeDisplayName["LLC"] = "Limited liability company (LLC)";
    LegalTypeDisplayName["LP"] = "Limited Partner (LP)";
    LegalTypeDisplayName["LTD"] = "Limited company (Ltd.)";
})(LegalTypeDisplayName || (LegalTypeDisplayName = {}));
export var LegalTypeCa;
(function (LegalTypeCa) {
    LegalTypeCa["INC"] = "INC";
    LegalTypeCa["LP"] = "LP";
    LegalTypeCa["LTD"] = "LTD";
})(LegalTypeCa || (LegalTypeCa = {}));
export var LegalTypeUs;
(function (LegalTypeUs) {
    LegalTypeUs["LLC"] = "LLC";
    LegalTypeUs["INC"] = "INC";
    LegalTypeUs["LP"] = "LP";
})(LegalTypeUs || (LegalTypeUs = {}));
export function getLegalTypeOptions(jurisdictionOfFormation) {
    if (jurisdictionOfFormation === 'CA') {
        return LegalTypeCa;
    }
    if (/^US_/.test(jurisdictionOfFormation)) {
        return LegalTypeUs;
    }
    return LegalType;
}
export function mapLegalTypeOptions(jurisdiction) {
    return Object.keys(getLegalTypeOptions(jurisdiction)).map(function (k) { return ({
        id: LegalType[k],
        name: LegalTypeDisplayName[k],
    }); });
}
export var jurisdictionOptions = Object.keys(JurisdictionOfFormation).map(function (k) { return ({
    id: JurisdictionOfFormation[k],
    name: JurisdictionDisplayName[k],
}); });
//# sourceMappingURL=helpers.js.map